/**
 * Image compression utility
 * Reduces mobile camera photos (3-10MB) to ~200-500KB for upload
 */

export async function compressImage(
  file: File,
  options: { maxWidth?: number; quality?: number } = {}
): Promise<{ base64: string; previewUrl: string }> {
  const { maxWidth = 1920, quality = 0.85 } = options;

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;

      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        URL.revokeObjectURL(img.src);
        reject(new Error('Canvas context not available'));
        return;
      }
      ctx.drawImage(img, 0, 0, width, height);

      const previewUrl = canvas.toDataURL('image/jpeg', quality);
      const base64 = previewUrl.split(',')[1];

      URL.revokeObjectURL(img.src);

      resolve({ base64, previewUrl });
    };
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error('Failed to load image'));
    };
    img.src = URL.createObjectURL(file);
  });
}
